import "./styles.css";
import React from "react";
import { SvgIcon } from "@mui/material";

export default function DialogBox({ title, color, icon }) {
  return (
    <div
      className="dialog"
      style={{ backgroundColor: color }}
      id="dialog-box-message-container"
    >
      <p
        style={{ color: "white" }}
        className="dialog-box-text"
        dangerouslySetInnerHTML={{ __html: title }}
        id="dialog-box-message"
      />
      <SvgIcon
        component={icon}
        sx={{ color: "#FFFFFF" }}
        id="dialog-box-icon"
      />
    </div>
  );
}
